import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { DynamicForm, CompanyProfileConfig } from '../../../../../components';

const CompanyProfile = ({
  photo,
  handleImgChange,
  companyProfileData,
  onSubmit,
  isLoading,
}) => {
  const { control, handleSubmit, formState: { errors } } = useForm({
    values: companyProfileData ?? {},
  });

  const filteredFields = CompanyProfileConfig.filter(
    (field) => !['name', 'tagline', 'phone_number'].includes(field.name)
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {/* Logo Upload */}
        <div className="gap-6 bg-white/5 p-4 rounded-xl shadow-lg backdrop-blur-sm">
          <div className="flex relative group">
            <img
              src={photo}
              alt="Logo"
              className="h-20 w-20 p-1 rounded-full object-cover ring-2 ring-cyan-400 group-hover:ring-cyan-300 transition duration-300 shadow-md"
            />
            <label
              htmlFor="logo-upload"
              className="absolute bottom-0 right-0 bg-cyan-600 p-1 rounded-full shadow-lg cursor-pointer hover:bg-cyan-400 transition"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-4 w-4 text-white"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
              <input
                id="logo-upload"
                type="file"
                name="logo"
                accept="image/*"
                onChange={handleImgChange}
                className="hidden"
              />
            </label>
          </div>
          <p className="text-sm text-cyan-200">Upload company logo</p>
          <p className="text-xs text-slate-300">Max size: 2MB | Format: JPG, PNG</p>
        </div>

        {/* Manual fields controlled by react-hook-form */}
        <div className="relative space-y-4">
          <div>
            <label htmlFor="name" className="text-sm text-cyan-300">Company Name</label>
            <Controller
              name="name"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="name"
                  type="text"
                  className="w-full bg-transparent border-b-2 border-cyan-500 text-white focus:outline-none focus:border-cyan-300"
                  placeholder="Company Name"
                />
              )}
            />
          </div>

          <div>
            <label htmlFor="tagline" className="text-sm text-cyan-300">Tagline</label>
            <Controller
              name="tagline"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="tagline"
                  type="text"
                  className="w-full bg-transparent border-b-2 border-cyan-500 text-white focus:outline-none focus:border-cyan-300"
                  placeholder="Tagline"
                />
              )}
            />
          </div>

          <div>
            <label htmlFor="phone_number" className="text-sm text-cyan-300">Telephone</label>
            <Controller
              name="phone_number"
              control={control}
              render={({ field }) => (
                <input
                  {...field}
                  id="phone_number"
                  type="text"
                  className="w-full bg-transparent border-b-2 border-cyan-500 text-white focus:outline-none focus:border-cyan-300"
                  placeholder="Telephone"
                />
              )}
            />
          </div>
        </div>
      </div>

      {/* The rest of the fields go here */}
      <div className="md:col-span-2">
        <DynamicForm
          data={companyProfileData}
          fields={filteredFields}
          onSubmit={onSubmit}
          isLoading={isLoading}
          control={control} // Pass shared control to DynamicForm
        />
      </div>
    </form>
  );
};

export default CompanyProfile;
